import React, { Component } from "react";

import CodeEditor from "../components/CodeEditor";

import {
  Row,
  DropdownButton,
  Button,
  MenuItem,
  Modal,
  Accordion,
  Panel,
  PageHeader,
  Table,
  Well,
  Tab,
  Grid,
  Col,
  Nav,
  NavItem
} from "react-bootstrap";

import 'font-awesome/css/font-awesome.css';
import FontAwesome from 'react-fontawesome';

import chai from "chai";

import JavascriptParser from "../parser/JavascriptParser";

import { runTest } from "../TestRunner";

import JsDiff from "../diff/Diff";

window.expect = chai.expect;

let currentTestContent = null;

const HAS_MOCK_INDICATOR = "• ";

function onChange(newValue, id) {
  currentTestContent = newValue;
  let metadata = JSON.parse(localStorage.getItem(id));
  metadata.content = newValue;
  localStorage.setItem(id, JSON.stringify(metadata));
}



function getExampleTest(props) {
  if (props.exampleTest == null) {
    return null;
  }
  return {
    id: props.exerciseId + "-" + props.exampleTest.name,
    name: props.exampleTest.name,
    mocks: null,
    content: props.exampleTest.content,
    example: true
  }
}

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}

export default class TestNavigator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showTestResult: false,
      showReport: false,
      showDiff: false,
      currentDiff: null,
      fileDiff: null,
      passed: true,
      errorMessage: null,
      selectedTestIndex: -1,
      testName: null,
      selectedMockIndex: -1,
      reportResults: null,
      mockContent: null
    };
  }

  onMockChanged = (newValue, currentMockName, id) => {
    let metadata = JSON.parse(localStorage.getItem(id));
    metadata.mocks[currentMockName] = newValue;
    localStorage.setItem(id, JSON.stringify(metadata));
    this.setState({mockContent: newValue});
  }

  handleTestNameChange = (id, event) => {
    let newName = event.target.value;
    let metadata = JSON.parse(localStorage.getItem(id));
    metadata.name = newName;
    localStorage.setItem(id, JSON.stringify(metadata));
    this.setState({testName: newName});
  }

  getMockContent = (testId, currentMockName) => {
    let metadataString = localStorage.getItem(testId);
    let metadata = JSON.parse(metadataString);
    if (metadata == null || metadata.mocks == null) {
      return "";
    }
    return metadata.mocks[currentMockName];
  }
  
  getMocks = (testId) => {
    let metadataString = localStorage.getItem(testId);
    let metadata = JSON.parse(metadataString);
    if (metadata == null) {
      return null;
    }
    return metadata.mocks;
  }

  testSelected = (eventKey, event) => {
    let index = eventKey.replace("test-", "");
    this.setState({selectedTestIndex: parseInt(index)});
  }

  mockSelected = (eventKey, event) => {
    let index = eventKey.replace("mock-", "");
    this.setState({selectedMockIndex: parseInt(index)});
  }

  viewDiff = (changeName) => {
    let unchangedFiles = this.props.files.filter(file => {
      if (this.props.hiddenFiles != null && this.props.hiddenFiles.some(filename => file.filename === filename)) {
        return false;
      }
      return file.filename.endsWith(".js");
    });

    let matchingChange = this.props.changes.filter(change => change.name === changeName);
    let changedFiles = matchingChange.get(0).files.filter((content, filename) => {
      if (this.props.hiddenFiles != null && this.props.hiddenFiles.some(hiddenFilename => filename === hiddenFilename)) {
        return false;
      }
      return filename.endsWith(".js");
    });

    let fileDiff = [];
    
    changedFiles.forEach((content, filename) => {
      let matchingUnchanged = unchangedFiles.filter(file => file.filename === filename);
      let previousContent = "";
      if (matchingUnchanged.length === 1) {
        previousContent = matchingUnchanged[0].content;
      }
      if (previousContent !== content) {
        let changes = JsDiff.diff(previousContent, content);
        fileDiff.push({filename: filename, changes});
      }
    });

    unchangedFiles.filter(file => changedFiles.every((content, filename) => file.filename !== filename)).forEach(file => {
      let changes = JsDiff.diff(file.content, "");
      fileDiff.push({filename: file.filename, changes});
    });

    this.setState({fileDiff, showDiff: true, currentDiff: changeName});
  }

  executeTest = (content, mocks, mockableFunctions) => {
    let error = runTest(content, mocks, mockableFunctions, this.props.files, this.props.hiddenFiles);
    let passed = error == null;
    let message = null;
    if (error != null) {
      message = error.message;
    }
    this.setState({showTestResult: true, passed, errorMessage: message});
  }

  addTest = () => {
    let testIds = localStorage.getItem(this.props.exerciseId);
    if (testIds == null || testIds === "") {
      testIds = [];
    } else {
      testIds = testIds.split(',');
    }
    
    const testId = guid();
    testIds.push(testId);
    localStorage.setItem(this.props.exerciseId + "-" + testId, JSON.stringify({
      name: "New Test",
      mocks: new Map(),
      content: ""
    }));
    localStorage.setItem(this.props.exerciseId, testIds);
    this.setState({selectedTestIndex: testIds.length});
  }

  removeTest = (testId, isExample) => {
    if (isExample) {
      return;
    }
    localStorage.removeItem(testId);
    let testIds = localStorage.getItem(this.props.exerciseId);
    if (testIds == null || testIds === "") {
      testIds = [];
    } else {
      testIds = testIds.split(',');
    }
    var index = testIds.indexOf(testId.replace(this.props.exerciseId+"-", ""));
    testIds.splice(index, 1);
    localStorage.setItem(this.props.exerciseId, testIds);
    this.setState({selectedTestIndex: this.state.selectedTestIndex-1});
  }

  runReport = (mockableFunctions) => {
    let results = [];
    this.props.changes.forEach(change => {
      let testShouldFail = change.shouldFail;
      if (testShouldFail == null) {
        testShouldFail = false;
      }
      let passingTests = 0;
      let failingTests = 0;
      let compilationFailures = 0;

      let changedFiles = []
      change.files.forEach((content, filename) => {
        changedFiles.push({
          content, 
          filename
        })
      });
      this.getUserTests().forEach(test => {

        let error = runTest(test.content, this.getMocks(test.id), mockableFunctions, changedFiles, this.props.hiddenFiles);
        let passed = error == null;
        if (passed) {
          passingTests++;
        } else {
          if (error instanceof SyntaxError || error instanceof ReferenceError) {
            compilationFailures++;
          } else {
            failingTests++;
          }
        }
      });
      
      let result = {
        name: change.name
      };
      let passed = true;
      if ((testShouldFail && failingTests === 0) || (!testShouldFail && failingTests !== 0) || compilationFailures !== 0) {
        passed = false;
        result.failMessage = change.failMessage;
      }
      result.passed = passed;
      result.type = "Refactor";
      if (testShouldFail) {
        result.type = "Bug";
      }
      results.push(result);
    })
    this.setState({showReport: true, reportResults: results});
  }

  closeTestResult = () => {
    this.setState({showTestResult: false});
  }

  closeReport = () => {
    this.setState({showReport: false});
  }

  closeDiff = () => {
    this.setState({showDiff: false});
  }

  getUserTests = () => {
    const id = this.props.exerciseId;
    let testIds = localStorage.getItem(id);
    if (testIds == null || testIds === "") {
      return [];
    } 
    
    testIds = testIds.split(',');
    
    return testIds.map(testId => { 
      const fullId = id + '-' + testId;
      const testMetadata = JSON.parse(localStorage.getItem(fullId));
      return {
        id: fullId,
        name: testMetadata.name,
        mocks: testMetadata.mocks,
        content: testMetadata.content
      }
    });
  }

  render() {
    let exampleTest = getExampleTest(this.props);
    let userTests = this.getUserTests();
    let tests = userTests;

    if (exampleTest != null) {
      tests = [exampleTest, ...userTests];
    }
    if (tests.length === 0) {
      tests = [{id: "None", name: "None", mocks: null, content: ""}];
    }
  
    let selectedTestIndex = this.state.selectedTestIndex;

    if (selectedTestIndex <= -1) {
      selectedTestIndex = tests.length - 1;
    }

    const dropdownItems = tests.map((test, index) => {
      return <MenuItem eventKey={"test-"+index}>{test.name}</MenuItem>;
    });
  
    currentTestContent = tests[selectedTestIndex].content;

    let mockableFunctions = JavascriptParser.getFunctions(this.props.files.map(file => file.content));

    let mockIndeciesWithConent = [];
    let mockDropdownItems = mockableFunctions.map((mockableFunction, index) => {
      let content = this.getMockContent(tests[selectedTestIndex].id, mockableFunction.displayName);
      let prefix = "";
      if (content != null && content !== "") {
        mockIndeciesWithConent.push(index);
        prefix = HAS_MOCK_INDICATOR;
      }
      return <MenuItem eventKey={"mock-"+index}>{prefix+mockableFunction.displayName}</MenuItem>;
    });

    let selectedMockIndex = this.state.selectedMockIndex;
    
    if (selectedMockIndex === -1) {
      if (mockIndeciesWithConent.length > 0) {
        selectedMockIndex = mockIndeciesWithConent[0];
      }
    }

    if (selectedMockIndex === -1) {
      selectedMockIndex = 0;
    }

    let currentMockName = "";
    let currentMockPrefix = ""
    if (mockableFunctions.length !== 0) {
      if (mockIndeciesWithConent.some(index => selectedMockIndex === index)) {
        currentMockPrefix = HAS_MOCK_INDICATOR;
      }
      currentMockName = mockableFunctions[selectedMockIndex].displayName;
    }

    let currentMockContent = this.getMockContent(tests[selectedTestIndex].id, currentMockName);

    return (
      <span>
        <Row className="with-margin">
          Select Test:
          <DropdownButton
            title={tests[selectedTestIndex].name}
            onSelect={this.testSelected}
            bsSize="xsmall"
            id="test-dropdown">
            {dropdownItems}
          </DropdownButton>
          { tests[selectedTestIndex].example &&
            <span>
              (example)
            </span>
          }
          <Button
            className="pull-right"
            bsStyle="danger"
            bsSize="xsmall"
            onClick={() => this.removeTest(tests[selectedTestIndex].id, tests[selectedTestIndex].example)}>
            Remove Test
          </Button>
          <Button
            className="pull-right"
            bsStyle="success btn-space"
            bsSize="xsmall"
            onClick={() => this.addTest()}>
            Create New Test
          </Button>
          
        </Row>
        { !tests[selectedTestIndex].example &&
          <Row className="with-margin">
            Change name:
            <input type="text" value={tests[selectedTestIndex].name} onChange={(event) => this.handleTestNameChange(tests[selectedTestIndex].id, event)} />
          </Row>
        }
        <Row className="with-margin">
          <a href="http://chaijs.com/api/bdd/">Chai assertions with expect</a> are supported
        </Row>
        <Row className="with-margin">
          <Accordion defaultActiveKey="panel-2">
            <Panel bsStyle="primary" header="Test Doubles" eventKey="panel-1">
              <Row className="with-margin">
                <DropdownButton
                  title={currentMockPrefix + currentMockName}
                  onSelect={this.mockSelected}
                  bsSize="xsmall"
                  id="test-dropdown">
                  {mockDropdownItems}
                </DropdownButton>
                <span>
                  Parameters: 
                  {(mockableFunctions.length === 0 || mockableFunctions[selectedMockIndex].parameters.length === 0)}
                  {(mockableFunctions.length !== 0 && mockableFunctions[selectedMockIndex].parameters.length !== 0) && mockableFunctions[selectedMockIndex].parameters.join()}
                </span>
              </Row>
              <Row>
                <CodeEditor id={"mock"+selectedTestIndex}
                  value={currentMockContent}
                  readOnly={tests[selectedTestIndex].example}
                  width="550px"
                  height="200px"
                  onChange={(newValue) => this.onMockChanged(newValue, currentMockName, tests[selectedTestIndex].id)}/>
              </Row>
            </Panel>
            <Panel bsStyle="primary" header="Test Source" eventKey="panel-2">
              <CodeEditor id={"test"+selectedTestIndex}
                value={currentTestContent}
                readOnly={tests[selectedTestIndex].example}
                width="550px"
                height="300px"
                onChange={(newValue) => onChange(newValue, tests[selectedTestIndex].id)}/>
            </Panel>
          </Accordion>
        </Row>
        <Row className="with-margin">
          <Button
            className="pull-right"
            bsStyle="primary"
            bsSize="small"
            onClick={() => this.runReport(mockableFunctions)}>
            Run report
          </Button>
          <Button 
            className="right-margin pull-right"
            bsStyle="primary"
            bsSize="small"
            onClick={() => this.executeTest(currentTestContent, this.getMocks(tests[selectedTestIndex].id), mockableFunctions)}>
            Execute
          </Button>
        </Row>
        <Modal
          show={this.state.showTestResult}
          onHide={this.closeTestResult}
          container={this}
          aria-labelledby="contained-modal-title" >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title">Test Result</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.passed ?
              "Success" :
              this.state.errorMessage
            }
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.closeTestResult}>Close</Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={this.state.showReport}
          onHide={this.closeReport}
          container={this}
          aria-labelledby="report-modal-title" >
          <Modal.Header closeButton>
            <Modal.Title id="report-modal-title">Report</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Well>
            {
              this.state.reportResults && 
              this.state.reportResults.every(result => result.passed) &&
              <div>
                <FontAwesome
                        name="check"
                        style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)' }}
                /> Congratulations! Your tests were put through the test of time and come out alive!
              </div>
            }
            {
              this.state.reportResults && 
              this.state.reportResults.some(result => !result.passed) &&
              <div>
                <FontAwesome
                        name="times"
                        style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)' }}
                /> Unfortunately, your tests did not stand up to the test of time. The following report shows which changes to the code were issues.
              </div>
            }
            </Well>
            { this.state.reportResults &&
            	<Table striped bordered condensed hover>
		            <thead>
			            <tr>
                  <th>Pass</th>
                  <th>Name of change</th>
                  <th>Type</th>
                  <th>Fail Description</th>
                  <th>View Changes</th>
                </tr>
              </thead>
              <tbody>
                {this.state.reportResults.map(result => {
                  let iconName = null;
                  if (result.passed) {
                    iconName = "check";
                  } else {
                    iconName = "times";
                  }
                  return <tr>
                    <td>
                      <center>
                      <FontAwesome
                        name={iconName}
                        style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)' }}
                      />
                      </center>
                    </td>
                    <td>{result.name}</td>
                    <td>{result.type}</td>
                    <td>{!result.passed && result.failMessage}</td>
                    <td>
                      <center>
                        <Button onClick={() => this.viewDiff(result.name)}>
                          <center>
                            <FontAwesome
                              name="eye"
                              style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)' }}
                            />
                          </center>
                        </Button>
                      </center>
                    </td>
                  </tr>
                })}
              </tbody>
            </Table>
            }
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.closeReport}>Close</Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={this.state.showDiff}
          bsSize="lg"
          onHide={this.closeDiff}
          container={this}
          aria-labelledby="contained-modal-title" >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title">Diff for {this.state.currentDiff}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.fileDiff &&
              <Tab.Container id="fileNavigator" defaultActiveKey="change-file0">
                <Grid flexible={true}>
                <Row className="clearfix">
                  <Col sm={2} className="nopadding">
                    <Nav className="tabs-left" bsStyle="tabs" stacked>
                      {this.state.fileDiff.map((diff, index) => {
                        return <NavItem key={index} eventKey={"change-file"+index}>{diff.filename}</NavItem>;
                      })}
                    </Nav>
                  </Col>
                  <Col sm={7} className="nopadding">
                    <Tab.Content animation>
                      {this.state.fileDiff.map((diff, index) => {
                        return (
                          <Tab.Pane eventKey={"change-file"+index}>
                            <pre style={{margin: '5px'}}>
                              {diff.changes.map(part => {
                                let color = part.added ? 'green' :
                                        part.removed ? 'red' : 'grey';
                                const spanStyle = {
                                  color: color
                                };

                                if (!part.added && !part.removed) {
                                  return part.value;
                                } else {
                                  return <strong style={spanStyle}>{part.value}</strong>;
                                }
                              })
                              }
                            </pre>
                          </Tab.Pane>
                        );
                      })}
                    </Tab.Content>
                  </Col>
                </Row>
                </Grid>
              </Tab.Container>


              
            }
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.closeDiff}>Close</Button>
          </Modal.Footer>
        </Modal>
      </span>
    );
  }
};


// WEBPACK FOOTER //
// ./src/components/TestNavigator.js